<script setup lang="ts">
import { computed } from 'vue'

import { useDefaults } from '../../composables'
import { isUiKitColor } from '../../utils/color-utils'

interface BIconProps {
	/** Icon name from Hugeicons free icon set. see: https://hugeicons.com/icons?style=Stroke&type=Rounded  */
	icon: string
	/** Size of the icon in px or string with units */
	size?: string | number
	/** Color of the icon, can be a color name from ui-kit like: `primary`, `on-surface` or a CSS color name, hex, rgb, etc. */
	color?: string
}

const _props = withDefaults(defineProps<BIconProps>(), {
	size: 16,
	color: undefined
})
const props = useDefaults(_props)

const computedStyles = computed(() => {
	const size = isNaN(+props.size) ? props.size : `${props.size}px`

	let color: string | undefined = undefined
	if (props.color) {
		color = isUiKitColor(props.color)
			? `var(--color-${props.color})`
			: props.color
	}

	return {
		fontSize: size,
		height: size,
		width: size,
		color
	}
})
</script>

<template>
	<i
		:class="[
			'inline-flex',
			'items-center',
			'justify-center',
			'hgi-stroke',
			'leading-0',
			`hgi-${props.icon}`,
			{ 'cursor-pointer': !!($attrs.onClick || $attrs.onClickOnce) }
		]"
		:style="computedStyles"
		role="img"
	/>
</template>
